import { render, staticRenderFns } from "./SecurityAuthLogin.vue?vue&type=template&id=2f28a367"
import script from "./SecurityAuthLogin.vue?vue&type=script&lang=js"
export * from "./SecurityAuthLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports